import React, { FC, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ReactComponent as FolderIcon } from "images/Folder.svg";
import { ReactComponent as TrashCanIcon } from "images/TrashCan.svg";
import { ReactComponent as EditIcon } from "images/EditorIcon.svg";
import { ReactComponent as RefreshIcon } from "images/Refresh.svg";
import { IFolder } from "toolkit/documents/folders/types";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { AddingFolder } from "../AddingFolder/AddingFolder";
import { ModalWindow } from "components/ModalWindow/ModalWindow";
import { DeleteWindow } from "../DeleteWindow/DeleteWindow";
import { RestoringFolder } from "../RestoringFolder/RestoringFolder";
import styles from "./Folder.module.sass";
import cn from "classnames";
import { deleteFolder } from "toolkit/documents/folders/folders.thunks";

interface FolderProps {
	folder: IFolder;
}

interface IModalWindow {
	content: React.ReactElement | null;
	visibility: boolean;
}

export const Folder: FC<FolderProps> = ({ folder }) => {
	const dispatch = useAppDispatch();
	const { documentOrganization } = useAppSelector((state) => state.documents);
	const { condition } = useParams();
	const [modalWindow, setModalWindow] = useState<IModalWindow>({
		content: null,
		visibility: false,
	});

	const openModalWindow = (component: React.ReactElement) => {
		setModalWindow({ ...modalWindow, content: component, visibility: true });
	};

	const closeModalWindow = () => {
		setModalWindow({ ...modalWindow, content: null, visibility: false });
	};

	const submitHandler = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		dispatch(deleteFolder({ folderId: folder.id }));
		closeModalWindow();
	};

	return (
		<>
			{modalWindow.visibility && (
				<ModalWindow close={closeModalWindow} scroll={false}>
					{modalWindow.content}
				</ModalWindow>
			)}
			<li className={styles.folder}>
				<Link to={`folders/${folder.id}`} state={{ folderName: folder.name }} className={styles.link}>
					<div className={styles["folder-item"]}>
						<div>
							<FolderIcon style={{ fill: `${folder.color}` }} />
						</div>
						<span className={styles["folder-name"]}>{folder.name}</span>
					</div>
					{!folder.base &&
						!documentOrganization?.archived &&
						(condition !== "archive" ? (
							<div onClick={(e) => e.preventDefault()} className={cn(styles["folder-item"], styles.btns)}>
								<button
									onClick={() =>
										openModalWindow(
											<AddingFolder title="Редактирование папки" folder={folder} close={closeModalWindow} />,
										)
									}
									className={styles.btn}>
									<EditIcon />
								</button>
								<button
									onClick={() =>
										openModalWindow(
											<DeleteWindow
												subtitle="В архив переместится папка и все её документы"
												onSubmit={(e) => submitHandler(e)}
												close={closeModalWindow}
											/>,
										)
									}
									className={styles.btn}>
									<TrashCanIcon />
								</button>
							</div>
						) : (
							<div onClick={(e) => e.preventDefault()} className={cn(styles["folder-item"], styles.btns)}>
								<button
									onClick={() => openModalWindow(<RestoringFolder folderId={folder.id} close={closeModalWindow} />)}
									className={styles.btn}>
									<RefreshIcon className={styles.refresh} />
								</button>
							</div>
						))}
				</Link>
			</li>
		</>
	);
};
